import { NgClass } from '@angular/common';
import { Component } from '@angular/core';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss'],
  imports: [NgClass]
})
export class NavbarComponent {
  navbarOpen = false;

  constructor() {
   }

  toggleNavbar() {
    this.navbarOpen = !this.navbarOpen;
  }
}
